/* eslint-disable react-hooks/exhaustive-deps */
/**
 * HomePageV2.jsx — auto-ported V2 of HomePage.jsx.
 *
 * Backend: uniapp-backend (`staging-api.uniapp.vn`) via datV2.
 * Fields: camelCase (sessionId / startTime / vehiclePlate / etc).
 * Response: { data, pagination } envelope (auto-unwrapped by uniappClient).
 *
 * See docs/v2-migration-from-n8n.md for the full migration guide.
 */
import { AgGridReact } from 'ag-grid-react';
import { useEffect, useState, useMemo, useRef } from 'react';
import datV2 from '../../services/datV2';
import integrationApi from '../../services/integration';
import { Button, Col, Container, Form, InputGroup, Nav, Row, Modal, Card } from 'react-bootstrap';
import drivingApi from '../../services/driving';
import { ELEARNING_STATUS_LABEL } from '../../constants/customer.constant';
import { LICENSE_GROUP } from '../../constants/license-class.constant';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import CopyableText from '../../components/CopyableText';
import { dungTruyVanKhachHang } from '../../utils/truyVanKhachHang';

// GetFly customer-group option ID for "XE - DỰ BỊ"
const RESERVE_GROUP_OPTION_ID = 19;
// Tra cứu lịch giảng KHÔNG lọc theo nhóm khách hàng nữa — xem
// `utils/truyVanKhachHang`. Danh sách nhóm cũ ([19,14,13,12,11]) gửi lên dưới
// dạng chuỗi nối phẩy, mà GetFly chỉ nhận một giá trị nên nó trả rỗng kèm mã
// 200: hỏng im lặng. Và `account_type` cũng không phải `relation_id`, nên bộ
// lọc đó chưa từng lọc đúng nhóm.

// Helper to get query param
function getQueryParam(param) {
  const params = new URLSearchParams(window.location.search);
  return params.get(param);
}

function SearchPageV2() {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [setting, setSetting] = useState(null);
  const [drivingClass, setDrivingClass] = useState('');
  // Khoá học để lọc — nạp từ chính options `khoa_hoc` của GetFly.
  const [courseId, setCourseId] = useState('');
  const [courseOptions, setCourseOptions] = useState([]);

  const [colDefs] = useState([
    {
      headerName: "STT",
      valueGetter: (params) => params.node ? params.node.rowIndex + 1 : '',
      width: 80,
      pinned: "left" // Cố định cột STT bên trái
    },
    {
      field: 'Chi tiết',
      headerName: 'Phiên học',
      cellRenderer: (params) => {
        const onClick = () => {
          window.open(
            `${window.location.origin}/search?name=${params.data['registrationCode']}`,
            '_blank'
          );
        };
        return (
          <Button size='sm' variant='primary' onClick={onClick} className='w-100'>
            Xem
          </Button>
        );
      },
      width: 100,
    },
    { field: 'name', headerName: 'Họ và tên',
      flex: 1,
      minWidth: 300,
      cellRenderer: (p) => <CopyableText value={p.value} />,
     },
    { field: 'courseShortName', headerName: 'Khoá học', flex: 1, minWidth: 80 },
    { field: 'registrationCode', headerName: 'Mã học viên', minWidth: 150, flex: 1, cellRenderer: (p) => <CopyableText value={p.value} /> },
    { field: 'dob', headerName: 'Ngày sinh', minWidth: 150, flex: 1 },
    { field: 'idCardNumber', headerName: 'Số CMND/CCCD/HC', minWidth: 150, flex: 1 },
  ]);
  const [rowData, setRowData] = useState([]);

  // State cho chức năng điều kiện DAT (GetFlyCustomerPage)
  const [datConditionLoading, setDatConditionLoading] = useState(false);
  const [showCustomerDetail, setShowCustomerDetail] = useState(false);
  const [showRetestModal, setShowRetestModal] = useState(false);
  const [customerData, setCustomerData] = useState(null);
  const [datConditionRowData, setDatConditionRowData] = useState([]);

  // 'condition' = Tra cứu điều kiện DAT (default modal); 'schedule' = Tra cứu lịch giảng (modal lịch giảng riêng cho nhóm 19)
  /* MỘT nguồn sự thật cho "đang xem báo cáo nào".
   *
   * Trước đây trạng thái này nằm rải ở hai biến: `activeTable` ('result' |
   * 'condition') và `searchMode` ('condition' | 'schedule'). Hai nút khác nhau
   * cùng đặt `activeTable = 'condition'`, nên muốn biết đang ở báo cáo nào
   * phải đọc cả hai và suy ra — dễ lệch, và chính vì thế mà giao diện trước
   * không hiện được báo cáo đang mở.
   *
   * Nay chỉ có `tab`; hai biến cũ suy ra từ nó để phần còn lại của file
   * không phải sửa theo. */
  const [tab, setTab] = useState('result'); // 'result' | 'condition' | 'schedule'
  const searchMode = tab === 'schedule' ? 'schedule' : 'condition';
  const [showScheduleModal, setShowScheduleModal] = useState(false);


  // react-hook-form for retest modal
  const {
    register: retestRegister,
    handleSubmit: handleRetestSubmit,
    formState: { errors: retestErrors },
    reset: resetRetestForm,
  } = useForm({
    defaultValues: {
      applicant: '',
      phone: '',
      paymentDate: '',
    },
  });
  
  const datConditionColDefs = useMemo(() => [
    {
      headerName: 'STT',
      valueGetter: (params) => (params.node ? params.node.rowIndex + 1 : ''),
      width: 80,
      pinned: 'left',
    },
    {
      field: 'detail',
      headerName: 'Chi tiết',
      cellRenderer: (params) => {
        return (
          <Button
            size='sm'
            variant='primary'
            onClick={() => {
              setCustomerData(params.data);
              if (searchMode === 'schedule') {
                setShowScheduleModal(true);
              } else {
                setShowCustomerDetail(true);
              }
            }}
            className='w-100'
          >
            Xem
          </Button>
        );
      },
      width: 100,
    },
    {
      field: 'account_name',
      headerName: 'Tên học viên',
      flex: 1,
      minWidth: 300,
    },
    {
      field: 'khoa_hoc_label',
      headerName: 'Khoá học',
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'ma_hoc_vien_theo_csdl',
      headerName: 'Mã học viên',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'birthday',
      headerName: 'Ngày sinh',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'can_cuoc_cong_dan',
      headerName: 'Số CMND/CCCD/HC',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'ngay_kham_suc_khoe',
      headerName: 'Ngày khám sức khỏe',
      minWidth: 150,
      flex: 1,
    },
  ], [searchMode]);

  // Nạp danh sách khoá cho dropdown. Dùng lại cache của `loadFieldDefs` nên
  // không tốn thêm lượt gọi GetFly nào.
  useEffect(() => {
    let huy = false;
    integrationApi
      .loadCourseOptions(25)
      .then((opts) => { if (!huy) setCourseOptions(opts); })
      // Không nạp được thì để dropdown rỗng và vẫn tra cứu bình thường —
      // mất bộ lọc còn hơn chặn cả màn hình.
      .catch(() => {});
    return () => { huy = true; };
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (showCustomerDetail || showScheduleModal) {
      // Fetch customer detail data when either modal opens
      getCustomerDetail(customerData?.account_id);
    }

    const fetchDrivingCenterSetting = async () => {
      try {
        const setting = await drivingApi.getDrivingCenterSetting();
        console.log('Driving Center Setting:', setting);
        setSetting(setting?.data || null);
      } catch (error) {
        console.error('Error fetching driving center setting:', error);
      }
    };

    fetchDrivingCenterSetting();
  }, [showCustomerDetail, showScheduleModal]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (showCustomerDetail && customerData?.mapper?.['ma_hoc_vien_theo_csdl']?.field_value) {
      // Fetch elearning status if registration code is available
      getElearningStatus(
        customerData?.mapper?.['ma_hoc_vien_theo_csdl']?.field_value,
        customerData?.mapper?.['can_cuoc_cong_dan']?.field_value,
        customerData?.mapper?.['ma_khoa_csdl']?.field_value,
      );
    }
  }, [
    showCustomerDetail,
    customerData?.mapper?.['ma_hoc_vien_theo_csdl']?.field_value,
  ]);

  const getElearningStatus = async (registrationCode, cardNumber, courseCode) => {
    setLoading(true);
    try {
      const {data} = await drivingApi.getElearningStatusByRegistrationCode(registrationCode, cardNumber, courseCode);
      setCustomerData(prev => ({
        ...prev,
        elearningStatus: data?.elearningStatus || 'created',
        elearningLastReportAt: data?.lastReportAt || null,
        elearningOver8hFlag: data?.elearningOver8hFlag || false,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const searchDatData = async (q) => {
    setLoading(true);
    try {
      const { data } = await datV2.searchStudent(q);
      setRowData(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Hàm lấy dữ liệu điều kiện DAT (giống GetFlyCustomerPage)
  const searchCustomerData = async (q) => {
    setDatConditionLoading(true);
    try {
      const data = await integrationApi.queryCustomers(q);
      const courses = data?.columns?.find((col => col.key === 'khoa_hoc'))?.options || [];
      const courseMap = courses.reduce((acc, course) => {
        acc[course.value] = course.label;
        return acc;
      }, {});
      data?.accounts.forEach((account) => {
        account.khoa_hoc_label = courseMap[account.khoa_hoc] || account.khoa_hoc;
      });
      setDatConditionRowData(data?.accounts || []);
    } catch (error) {
      console.error(error);
    } finally {
      setDatConditionLoading(false);
    }
  };

  // Hàm lấy chi tiết học viên (giống GetFlyCustomerPage)
  const getCustomerDetail = async (customerId) => {
    setDatConditionLoading(true);
    try {
      const data = await integrationApi.getCustomerDetail(customerId);

      if (data) {
        setCustomerData(prev => ({
          ...prev,
          ...data,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDatConditionLoading(false);
    }
  };

  const registerForRetest = async (formData) => {
    setLoading(true);

    try {
      // Tính số lần thi lại: lấy oto_dang_ky_thi_lai.field_value, ép kiểu số và +1; nếu không hợp lệ thì mặc định 1
      const rawRetestCount = parseInt(customerData?.mapper?.['oto_dang_ky_thi_lai']?.field_value, 10);
      const retestCount = Number.isFinite(rawRetestCount) && rawRetestCount > 0 ? rawRetestCount + 1 : 1;

      // Build retestText from selected categories
      const selectedCategories = [];
      if (selectedRetestCategories.theory) selectedCategories.push('Lý thuyết');
      if (selectedRetestCategories.simulation) selectedCategories.push('Mô phỏng');
      if (selectedRetestCategories.practice) selectedCategories.push('Sa hình');
      if (selectedRetestCategories.road) selectedCategories.push('Đường trường');
      const retestText = selectedCategories.join(', ');

      await integrationApi.registerRetestBC(customerData?.account_id, {
        ...formData,
        retestCount,
        retestText,
      });
      toast('Đăng ký thi lại thành công!', { type: 'success' });
      getCustomerDetail(customerData?.account_id);
    } catch (error) {
      console.error(error);
      toast('Đăng ký thi lại thất bại do lỗi hệ thống.', { type: 'error' });
    } finally {
      setLoading(false);
      resetRetestForm();
      setShowRetestModal(false);
      setShowCustomerDetail(true);
    }
  };

  // Check if payment date is still valid (today or in the future)
  const isPaymentDateValid = useMemo(() => {
    const paymentDateStr = customerData?.mapper?.['oto_ngay_nop_tien_thi_lai']?.field_value || '';
    if (!paymentDateStr) return true; // If no payment date, consider as valid

    // Parse dd/mm/yyyy format
    const parts = paymentDateStr.split('/');
    if (parts.length !== 3) return true; // Invalid format, consider as valid
    
    const paymentDate = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    paymentDate.setHours(0, 0, 0, 0);

    // Return true if payment date is today or in the future, false if it's past
    return paymentDate >= today;
  }, [customerData]);

  // Show retest info if registered AND payment date is still valid
  const retestRegistered = useMemo(() => {
    const registrationValue = parseInt(customerData?.mapper?.['oto_dang_ky_thi_lai']?.field_value, 10);
    const hasRegistration = Number.isFinite(registrationValue) && registrationValue > 0;
    return hasRegistration && isPaymentDateValid;
  }, [customerData, isPaymentDateValid]);

  // Check if can register retest: either no registration or payment date has passed
  const canRegisterRetestBtn = useMemo(() => {
    const registrationValue = parseInt(customerData?.mapper?.['oto_dang_ky_thi_lai']?.field_value, 10);
    const hasRegistration = Number.isFinite(registrationValue) && registrationValue > 0;
    
    // Can register if: no registration OR (has registration AND payment date has passed)
    return !hasRegistration || !isPaymentDateValid;
  }, [customerData, isPaymentDateValid]);

  // Calculate retest count for display
  const retestCount = useMemo(() => {
    const rawValue = parseInt(customerData?.mapper?.['oto_dang_ky_thi_lai']?.field_value, 10);
    return Number.isFinite(rawValue) && rawValue > 0 ? rawValue : 0;
  }, [customerData]);

  // Retest category prices
  const retestCategoryPrices = useMemo(() => {
    const theoryResult = customerData?.mapper?.['sh_ly_thuyet_kq']?.display_value?.toLowerCase() || '';
    const simulationResult = customerData?.mapper?.['sh_mo_phong_kq']?.display_value?.toLowerCase() || '';
    const practiceResult = customerData?.mapper?.['sh_sa_hinh_kq']?.display_value?.toLowerCase() || '';
    const roadResult = customerData?.mapper?.['sh_dg_truog_kq']?.display_value?.toLowerCase() || '';
    const relationIdResult = customerData?.mapper?.['relation_id']?.display_value?.toLowerCase() || '';

    // Treat absent (vắng) same as failed (rớt) for pricing
    const isFailed = relationIdResult.includes('rớt') || relationIdResult.includes('vắng');

    return {
      theory: {
        name: 'Lý thuyết',
        price: 100000,
        available: (theoryResult.includes('rớt') || theoryResult.includes('vắng')),
        result: theoryResult,
        isFailed: theoryResult.includes('rớt') || theoryResult.includes('vắng'),
      },
      simulation: {
        name: 'Mô phỏng',
        price: 100000,
        available: (simulationResult.includes('rớt') || simulationResult.includes('vắng')),
        result: simulationResult,
        isFailed: simulationResult.includes('rớt') || simulationResult.includes('vắng'),
      },
      practice: {
        name: 'Sa hình',
        price: 350000,
        available: (practiceResult.includes('rớt') || practiceResult.includes('vắng')),
        result: practiceResult,
        isFailed: practiceResult.includes('rớt') || practiceResult.includes('vắng'),
      },
      road: {
        name: 'Đường trường',
        price: 80000,
        available: (roadResult.includes('rớt') || roadResult.includes('vắng')),
        result: roadResult,
        isFailed: roadResult.includes('rớt') || roadResult.includes('vắng'),
      },
      isFailed: isFailed,
    };
  }, [customerData]);

  // State for selected retest categories
  const [selectedRetestCategories, setSelectedRetestCategories] = useState({
    absent: false,
    theory: false,
    simulation: false,
    practice: false,
    road: false,
  });

  // Calculate cumulative price (sum selected categories)
  const selectedRetestPrice = useMemo(() => {
    let total = 0;
    if (selectedRetestCategories.theory) total += retestCategoryPrices.theory.price;
    if (selectedRetestCategories.simulation) total += retestCategoryPrices.simulation.price;
    if (selectedRetestCategories.practice) total += retestCategoryPrices.practice.price;
    if (selectedRetestCategories.road) total += retestCategoryPrices.road.price;
    return total;
  }, [selectedRetestCategories, retestCategoryPrices]);

  // Update selected categories when modal opens
  useEffect(() => {
    if (showRetestModal && !retestRegistered) {
      // Don't auto-select - let user choose
      setSelectedRetestCategories({
        absent: false,
        theory: false,
        simulation: false,
        practice: false,
        road: false,
      });
    }
  }, [showRetestModal, retestRegistered]);

  // Check if student can register for retest (must have failed or absent exam)
  const canRegisterForRetest = useMemo(() => {
    const satHachResult = customerData?.mapper?.['datrot_sat_hach']?.display_value?.toLowerCase() || '';
    const hasFailedOrAbsent = satHachResult.includes('rớt') || satHachResult.includes('vắng');

    // BC1 retest requires relation_id (TIẾN ĐỘ ĐÀO TẠO) to be in one of the
    // following states: ĐẠT ĐIỀU KIỆN SÁT HẠCH, VẮNG SÁT HẠCH, RỚT SÁT HẠCH
    const relationId = (customerData?.mapper?.['relation_id']?.display_value || '').toUpperCase();
    const allowedRelationStates = [
      'ĐẠT ĐK SÁT HẠCH',
      'VẮNG SÁT HẠCH',
      'RỚT SÁT HẠCH',
    ];
    const hasValidRelationState = allowedRelationStates.some((state) =>
      relationId.includes(state),
    );

    return hasFailedOrAbsent && hasValidRelationState;
  }, [customerData]);

  // Payment info
  const paymentInfo = useMemo(() => ({
    bankName: 'VietinBank',
    bankAccount: '115002952167',
    bankCode: 'ICB',
    bankOwner: 'CTY TNHH MTV VI TINH QUANG MINH PHAT',
  }), []);

  // Today string for date validation (YYYY-MM-DD)
  const todayStr = useMemo(() => new Date().toISOString().split('T')[0], []);

  const currencyFormatter = useMemo(() => new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }), []);

  const [qrLoading, setQrLoading] = useState(false);

  // Unified retest transfer note used for display, copy and QR encoding
  const retestTransferNote = useMemo(() => {
    const accountCode = customerData?.mapper?.['account_code']?.display_value || '';
    const name = customerData?.mapper?.['account_name']?.display_value || '';
    const birthday = customerData?.mapper?.['birthday']?.display_value || '';
    const note = `${name} ${birthday} ${accountCode}`;
    return note;
  }, [customerData]);

  // QR URL with amount
  const retestQrUrlWithAmount = useMemo(() => {
    const amount = selectedRetestPrice || 0;
    return `https://img.vietqr.io/image/${paymentInfo.bankCode}-${paymentInfo.bankAccount}-WHQo7yS.jpg?amount=${amount}&addInfo=${encodeURIComponent(retestTransferNote)}&accountName=${encodeURIComponent(paymentInfo.bankOwner)}`;
  }, [selectedRetestPrice, paymentInfo, retestTransferNote]);

  // Keep old name for backward compatibility
  const retestQrUrl = retestQrUrlWithAmount;

  useEffect(() => {
    if (retestQrUrl) setQrLoading(true);
  }, [retestQrUrl]);

  const handleQrLoad = () => setQrLoading(false);
  const handleQrError = () => setQrLoading(false);

  // Copy button component
  function CopyButton({ text, iconOnly = false, title = 'Sao chép' }) {
    const [copied, setCopied] = useState(false);
    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (e) {
        console.error('Copy failed', e);
      }
    };

    const CopySvg = () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
      </svg>
    );

    if (iconOnly) {
      return (
        <Button variant='light' size='sm' onClick={handleCopy} title={title}>
          {copied ? '✓' : <CopySvg />}
        </Button>
      );
    }

    return (
      <Button variant='light' size='sm' onClick={handleCopy} title={title}>
        {copied ? '✓' : <><CopySvg />&nbsp;Sao chép</>}
      </Button>
    );
  }

  // Hàm xử lý tra cứu điều kiện DAT
  // Hàm xử lý tra cứu lịch giảng — lọc theo các nhóm liên quan (19, 14, 13, 12, 11)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = 'Tra cứu DAT';
    // If drivingClass is not set but URL has 'c', set it
    if (!drivingClass) {
      const c = getQueryParam('hang');

      if (c) {
        const licenseClass = LICENSE_GROUP.find(
          (license) => license.list_value?.toLowerCase() === c?.toLowerCase()
        );
        if (licenseClass) setDrivingClass(licenseClass.list_value);
      }
    }
  }, []);

  const activeTable = tab === 'result' ? 'result' : 'condition';

  /* Một truy vấn = tên + nhóm + khoá. Dùng làm chữ ký để biết dữ liệu của một
     tab có còn đúng với bộ lọc hiện tại không. */
  const truyVan = `${name.trim()}|${drivingClass}|${courseId}`;
  const daNap = useRef({});           // tab -> chữ ký lúc nạp
  const [daTim, setDaTim] = useState(false);

  /* Chạy đúng phép tra của một tab.
   *
   * `batBuoc = false` thì bỏ qua khi tab đó đã nạp với CHÍNH chữ ký này — đó
   * là phần cache: quay lại tab cũ hiện ngay, không gọi lại mạng. Đổi bộ lọc
   * làm chữ ký đổi, nên lần sau vào tab đó sẽ nạp lại. */
  const chayTab = (t, batBuoc = false) => {
    if (!name.trim()) return;
    if (!batBuoc && daNap.current[t] === truyVan) return;
    daNap.current[t] = truyVan;
    setDaTim(true);

    if (t === 'result') {
      let bo = name.normalize('NFD').replace(/[̀-ͯ]/g, '');
      bo = bo.replace(/[đĐ]/g, (m) => (m === 'đ' ? 'd' : 'D'));
      searchDatData({ name: bo, ...(drivingClass && { drivingClass }) });
      return;
    }

    const licenseClass = LICENSE_GROUP.find((lc) => lc.list_value === drivingClass);
    // Dựng tham số ở `utils/truyVanKhachHang` — dùng chung với HomePage v1,
    // vì đoạn này từng tồn tại hai bản và cùng mang một con bug.
    searchCustomerData(dungTruyVanKhachHang(t === 'schedule' ? 'schedule' : 'condition', {
      name,
      courseId,
      optionIdHang: licenseClass && licenseClass.list_option_id,
    }));
  };

  /* Đổi NHÓM hoặc KHOÁ thì chạy lại ngay tab đang mở.
   *
   * Cố ý KHÔNG theo dõi `name`: gõ tên là gõ dở liên tục, mỗi phím một lượt
   * gọi GetFly. Tên chỉ chạy khi người dùng chủ động — bấm Tìm hoặc Enter.
   *
   * Và chỉ chạy sau khi đã tra ít nhất một lần: lúc mới vào trang, đổi bộ lọc
   * chưa có nghĩa gì vì chưa có tên để tìm. */
  useEffect(() => {
    if (!daTim) return;
    chayTab(tab, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drivingClass, courseId]);

  return (
    <Container
      style={{
        height: '100vh',
      }}
      fluid
    >
      {/* Tiêu đề mang động từ "Tra cứu", nên ba nút bên dưới không cần lặp lại
          nó nữa — chúng chỉ cần gọi tên báo cáo mà chúng mở. Bỏ `height: '10%'`
          vì một dòng chữ không đáng chiếm một phần mười màn hình của một công
          cụ mà phần có giá trị là cái bảng bên dưới. */}
      <Row className='align-items-center py-2'>
        <Col>
          <h1 className='h5 mb-0'>Tra cứu DAT</h1>
        </Col>
      </Row>

      {/* Thanh lọc chỉ trả lời "tìm AI" — tên + nhóm + khoá cùng dựng một truy
          vấn nên gộp thành một `InputGroup` liền. Việc "xem BÁO CÁO nào" đã
          chuyển xuống hàng tab ngay trên bảng, vì đó mới là thứ tab điều khiển.
          10 + 2 = 12 chẵn ở `lg`; dưới `lg` ô Tìm xuống dòng, không đan xen. */}
      <Row className='g-2 align-items-center mb-3'>
        <Col xs={12} lg={10}>
          <InputGroup>
            <Form.Control
              type='text'
              aria-label='Tên học viên'
              placeholder='Tên học viên'
              // Ô tên là thứ người dùng gõ vào, không được nhỏ hơn hai ô chọn
              // bên cạnh. Sàn 280 đủ rộng để ở 390px nó chiếm trọn dòng đầu và
              // đẩy hai ô chọn xuống dòng dưới nằm cạnh nhau — thay vì cả ba
              // chen một dòng và bóp nhau còn ~55px như trước.
              style={{ minWidth: 280 }}
              value={name}
              onChange={(e) => setName(e.target.value)}
              // Enter chạy lại tab đang mở. Tên KHÔNG tự chạy khi gõ — mỗi phím
              // một lượt gọi GetFly, mà tên thì luôn gõ dở.
              onKeyDown={(e) => {
                if (e.key === 'Enter') chayTab(tab, true);
              }}
            />
            {/* "Mọi nhóm" chứ không phải "Chọn nhóm": không chọn gì nghĩa là
                không lọc, nên nhãn phải nói đúng điều đó. */}
            <Form.Select
              aria-label='Nhóm hạng'
              // Có SÀN chứ không chỉ có trần: flex cho phép co dưới cả nội
              // dung, nên ở 390px hai ô này từng bị bóp còn ~55px, hiện "Mọi ⌄"
              // cụt. Có sàn thì cả nhóm buộc phải xuống dòng thay vì bóp.
              style={{ minWidth: 130, maxWidth: 150 }}
              value={drivingClass}
              onChange={(e) => setDrivingClass(e.target.value)}
            >
              <option value=''>Mọi nhóm</option>
              {LICENSE_GROUP.map((license) => (
                <option key={license.list_option_id} value={license.list_value}>
                  {license.list_value}
                </option>
              ))}
            </Form.Select>
            <Form.Select
              aria-label='Khoá học'
              style={{ minWidth: 150, maxWidth: 180 }}
              value={courseId}
              onChange={(e) => setCourseId(e.target.value)}
            >
              <option value=''>Mọi khoá</option>
              {courseOptions.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </Form.Select>
          </InputGroup>
        </Col>

        <Col xs={12} lg={2}>
          <Button
            className='w-100'
            variant='primary'
            disabled={loading || datConditionLoading}
            onClick={() => chayTab(tab, true)}
          >
            Tìm
          </Button>
        </Col>
      </Row>
      {/* Tab nằm SÁT mép trên bảng mà nó điều khiển.
          Ở lượt thiết kế trước ba báo cáo này là một `ButtonGroup` trên thanh
          lọc — mang hình hài của tab mà hành vi lại là "chạy báo cáo", nên nó
          hứa đổi-ngay rồi trả về spinner. Đặt đúng chỗ và đặt đúng tên thì lời
          hứa mới khớp việc: đổi tab chỉ nạp phần còn thiếu, tab đã nạp với
          cùng bộ lọc thì hiện lại ngay. */}
      <Nav
        variant='tabs'
        activeKey={tab}
        onSelect={(k) => {
          if (!k || k === tab) return;
          setTab(k);
          chayTab(k);
        }}
      >
        <Nav.Item><Nav.Link eventKey='result'>Kết quả</Nav.Link></Nav.Item>
        <Nav.Item><Nav.Link eventKey='condition'>Điều kiện</Nav.Link></Nav.Item>
        <Nav.Item><Nav.Link eventKey='schedule'>Lịch giảng</Nav.Link></Nav.Item>
      </Nav>

      {!daTim ? (
        /* Màn rỗng là lời mời, không phải thông báo trống rỗng. */
        <p className='text-center text-muted py-5 mb-0 border border-top-0'>
          Nhập tên học viên rồi bấm Tìm.
        </p>
      ) : activeTable === 'result' ? (
        loading ? (
          <p className='text-center py-5 mb-0 border border-top-0'>Đang tìm…</p>
        ) : (
          <div className='ag-theme-quartz' style={{ height: '65%' }}>
            {rowData.length ? (
              <AgGridReact rowData={rowData} columnDefs={colDefs} />
            ) : (
              <p className='text-center py-5 mb-0'>Không tìm thấy học viên nào khớp.</p>
            )}
          </div>
        )
      ) : datConditionLoading ? (
        <p className='text-center py-5 mb-0 border border-top-0'>Đang tìm…</p>
      ) : (
        <div className='ag-theme-quartz' style={{ height: '65%' }}>
          {datConditionRowData.length ? (
            <AgGridReact
              rowData={datConditionRowData}
              columnDefs={datConditionColDefs}
            />
          ) : (
            <p className='text-center py-5 mb-0'>Không tìm thấy học viên nào khớp.</p>
          )}
        </div>
      )}
      {/* Modal chi tiết học viên giống GetFlyCustomerPage */}
      <Modal
        show={showCustomerDetail}
        onHide={() => {
          setShowCustomerDetail(false);
          setCustomerData(null);
        }}
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>Thông tin chi tiết</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {datConditionLoading ? (
            <p className='text-center'>Đang tải dữ liệu...</p>
          ) : (
            <div>
              <p className='text-danger'>
                - Các trường hợp dạy DAT ngoài thời gian quy định và Giáo viên -
                xe ngoài Báo cáo 1 cần phải được lập lịch điều chỉnh trước khi
                học DAT.
              </p>
              <Row>
                <Col md={12}>
                  <Card className='mb-3'>
                    <Card.Header>
                      <Card.Title>Thông tin cơ bản</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <p>
                        Tên học viên:{' '}
                        {customerData?.mapper?.['account_name']
                          ?.display_value || 'Không có dữ liệu'}
                      </p>
                      {/* <p>
                        Mã khoá học:{' '}
                        {customerData?.mapper?.['ma_khoa_csdl']
                          ?.display_value || 'Không có dữ liệu'}
                      </p> */}
                      <p>
                        Tên khoá học:{' '}
                        {customerData?.mapper?.['khoa_hoc']?.display_value ||
                          'Không có dữ liệu'}
                      </p>
                      <p>
                        Mã học viên:{' '}
                        {customerData?.mapper?.['ma_hoc_vien_theo_csdl']
                          ?.display_value || 'Không có dữ liệu'}
                      </p>
                      <p>
                        Ngày sinh:{' '}
                        {customerData?.mapper?.['birthday']?.display_value ||
                          'Không có dữ liệu'}
                      </p>
                      <p>
                        Số CMND/CCCD/HC:{' '}
                        {customerData?.mapper?.['can_cuoc_cong_dan']
                          ?.display_value || 'Không có dữ liệu'}
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={12}>
                  <Card className='mb-3'>
                    <Card.Header>
                      <Card.Title>Thông tin học tập</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <p>
                        <strong>GIỜ HỌC LÝ THUYẾT:</strong>{' '}
                        {(() => {
                          const over8hCourses = ['BSS-K26', 'BTĐ-K26', 'C1-K18'];
                          const currentCourse = customerData?.mapper?.['khoa_hoc']?.display_value || '';
                          const isOver8h = customerData?.elearningOver8hFlag && over8hCourses.includes(currentCourse);
                          return (
                            <span
                              className={
                                customerData?.elearningStatus === 'completed' && !isOver8h
                                  ? 'text-success'
                                  : 'text-danger'
                              }
                            >
                              {isOver8h
                                ? 'Học viên đã học quá 8 tiếng'
                                : (ELEARNING_STATUS_LABEL[
                                    customerData?.elearningStatus
                                  ] || 'Không có dữ liệu')}{' '}
                            </span>
                          );
                        })()}
                        {!['', 'created'].includes(
                          customerData?.elearningStatus,
                        ) && (
                          <span>
                            (Ngày:{' '}
                            {customerData?.elearningLastReportAt
                              ? new Date(
                                  customerData?.elearningLastReportAt,
                                ).toLocaleString('vi-VN')
                              : 'Không có dữ liệu'}
                            )
                          </span>
                        )}
                      </p>
                      {(() => {
                        const over8hCourses = ['BSS-K26', 'BTĐ-K26', 'C1-K18'];
                        const currentCourse = customerData?.mapper?.['khoa_hoc']?.display_value || '';
                        const isOver8h = customerData?.elearningOver8hFlag && over8hCourses.includes(currentCourse);
                        return isOver8h ? (
                          <p className='text-danger fw-bold'>
                            {`Học viên đã học quá 8 giờ/ngày. Vui lòng thông báo học viên kiểm tra báo cáo học tập (Kết quả học tập > Tải báo cáo PDF) để học bổ sung.`}
                          </p>
                        ) : null;
                      })()}
                      {
                        (customerData?.mapper?.['cabin_dt']?.display_value ===
                          '' || customerData?.mapper?.['cabin_dt']?.display_value === 'Chưa học CB') &&
                        customerData?.elearningStatus === 'completed' &&
                        !(customerData?.elearningOver8hFlag && ['BSS-K26', 'BTĐ-K26', 'C1-K18'].includes(customerData?.mapper?.['khoa_hoc']?.display_value || '')) &&
                        (
                          <Button
                            variant='primary'
                            onClick={() => {
                              window.location.href = `/cabin?account_id=${customerData?.account_id}`;
                            }}
                            target='_blank'
                            className='mb-3'
                          >
                            Đăng ký giờ học cabin điện tử
                          </Button>
                        )
                      }
                      <p>
                        <strong>NGÀY HỌC DAT:</strong>{' '}
                        {customerData?.mapper?.['ngay_hoc_dat']
                          ?.display_value || 'Không có dữ liệu'}
                      </p>
                      <p>
                        <strong>DEADLINE DAT:</strong>{' '}
                        {customerData?.mapper?.['ngay_be_giang']
                          ?.display_value || 'Không có dữ liệu'}
                      </p>
                      <p>
                        <strong>NGÀY KHÁM SỨC KHỎE:</strong>{' '}
                        {customerData?.mapper?.['ngay_kham_suc_khoe']
                          ?.display_value ? (
                          <span
                            className={
                              customerData?.mapper?.['ngay_kham_suc_khoe']
                                ?.field_value === '1'
                                ? 'text-success'
                                : ''
                            }
                          >
                            {customerData?.mapper?.['ngay_kham_suc_khoe']
                              ?.display_value || 'CẦN BỔ SUNG'}
                          </span>
                        ) : (
                          <span className='text-danger'>CẦN BỔ SUNG</span>
                        )}
                      </p>
                      <p>
                        <strong>GIÁO VIÊN BC1:</strong>{' '}
                        {customerData?.mapper?.['giao_vien_bc1']
                          ?.display_value || 'Không có dữ liệu'}
                      </p>
                      <p>
                        <strong>XE BC1:</strong>{' '}
                        {customerData?.mapper?.['xe_bc1']?.display_value ||
                          'Không có dữ liệu'}{' '}
                        <span className='text-danger'>
                          (
                          {customerData?.mapper?.['het_han_gptl']
                            ?.display_value || 'Không có dữ liệu'}
                          )
                        </span>
                      </p>
                      <p>
                        <strong>KIỂM TRA LÝ THUYẾT:</strong>{' '}
                        <span
                          className={
                            customerData?.mapper?.['ket_qua_ktra_5_mon']
                              .field_value === '312'
                              ? 'text-success'
                              : ''
                          }
                        >
                          {customerData?.mapper?.['ket_qua_ktra_5_mon']
                            ?.display_value || 'Không có dữ liệu'}
                        </span>
                      </p>
                      <p>
                        <strong>KIỂM TRA MÔ PHỎNG:</strong>{' '}
                        <span
                          className={
                            customerData?.mapper?.['kq_mo_phong']
                              .field_value === '261'
                              ? 'text-success'
                              : ''
                          }
                        >
                          {customerData?.mapper?.['kq_mo_phong']
                            ?.display_value || 'Không có dữ liệu'}
                        </span>
                      </p>
                      <p>
                        <strong>CABIN ĐIỆN TỬ:</strong>{' '}
                        {customerData?.mapper?.['cabin_dt']?.display_value ||
                          'Không có dữ liệu'}
                      </p>
                      <p>
                        <strong>TIẾN ĐỘ ĐÀO TẠO:</strong>{' '}
                        {customerData?.mapper?.['relation_id']?.display_value ||
                          'Không có dữ liệu'}
                      </p>
                      <p>
                        <strong>SH - ĐẠT/RỚT SÁT HẠCH:</strong>{' '}
                        {customerData?.mapper?.['datrot_sat_hach']
                          ?.display_value || 'Không có dữ liệu'}
                      </p>
                      <p>
                        <strong>SH - NGÀY THI GẦN NHẤT:</strong>{' '}
                        {customerData?.mapper?.['sh_ngay_thi_gan_nhat']
                          ?.display_value || 'Không có dữ liệu'}
                      </p>
                      {canRegisterForRetest &&
                        (setting?.allowRetestingBC ? (
                          <Button
                            variant='warning'
                            onClick={() => {
                              setShowCustomerDetail(false);
                              setShowRetestModal(true);
                            }}
                            className='mt-3'
                            disabled={!canRegisterRetestBtn || loading}
                          >
                            Đăng ký thi lại
                          </Button>
                        ) : (
                          <Button
                            variant='warning'
                            onClick={() => {
                              setShowCustomerDetail(false);
                              setShowRetestModal(true);
                            }}
                            className='mt-3'
                            disabled={!setting?.allowRetestingBC || loading}
                          >
                            Đăng ký thi lại
                          </Button>
                        ))}
                      {setting?.allowRetestingBC ? null : (
                        <p className='text-danger'>
                          Trung tâm chưa mở đợt đăng ký thi lại
                        </p>
                      )}
                      {retestRegistered && (
                        <div className='mt-3'>
                          <div className='alert alert-success mb-3'>
                            <strong>
                              ✓ Đã đăng ký thi lại (Lần {retestCount})
                            </strong>
                          </div>
                          <Row>
                            <Col className='mb-3'>
                              <Card className='bg-light h-100'>
                                <Card.Header>
                                  <Card.Title>
                                    Thông tin đăng ký thi lại
                                  </Card.Title>
                                </Card.Header>
                                <Card.Body>
                                  <p>
                                    <strong>Lần đăng ký:</strong> Lần{' '}
                                    {retestCount}
                                  </p>
                                  <p>
                                    <strong>Hạng mục đăng ký:</strong>{' '}
                                    {customerData?.mapper?.[
                                      'oto_hang_muc_dang_ky_thi_lai'
                                    ]?.display_value || 'Không có dữ liệu'}
                                  </p>
                                  <p>
                                    <strong>Người nộp hồ sơ:</strong>{' '}
                                    {customerData?.mapper?.[
                                      'oto_nguoi_dang_ky_thi_lai'
                                    ]?.display_value || 'Không có dữ liệu'}
                                  </p>
                                  <p>
                                    <strong>Số điện thoại:</strong>{' '}
                                    {customerData?.mapper?.[
                                      'oto_sdt_nguoi_dang_ky_tl'
                                    ]?.display_value || 'Không có dữ liệu'}
                                  </p>
                                  <p>
                                    <strong>Ngày nộp tiền:</strong>{' '}
                                    {customerData?.mapper?.[
                                      'oto_ngay_nop_tien_thi_lai'
                                    ]?.display_value || 'Không có dữ liệu'}
                                  </p>
                                </Card.Body>
                              </Card>
                            </Col>
                            {/* <Col md={6}>
                              <Card className='bg-light h-100'>
                                <Card.Header>
                                  <Card.Title>Thông tin thanh toán</Card.Title>
                                </Card.Header>
                                <Card.Body>
                                  <Row>
                                    <Col md={12} className='mb-2'>
                                      <p>
                                        <strong>Ngân hàng:</strong>{' '}
                                        {paymentInfo.bankName}{' '}
                                        <CopyButton
                                          text={paymentInfo.bankName}
                                          iconOnly
                                          title='Sao chép ngân hàng'
                                        />
                                      </p>
                                      <p>
                                        <strong>Số tài khoản:</strong>{' '}
                                        {paymentInfo.bankAccount}{' '}
                                        <CopyButton
                                          text={paymentInfo.bankAccount}
                                          iconOnly
                                          title='Sao chép số tài khoản'
                                        />
                                      </p>
                                      <p>
                                        <strong>Chủ tài khoản:</strong>{' '}
                                        {paymentInfo.bankOwner?.toUpperCase()}
                                      </p>
                                    </Col>
                                    <Col md={12} className='text-center'>
                                      <div
                                        className='position-relative d-inline-block'
                                        style={{ maxWidth: 220 }}
                                      >
                                        {qrLoading && (
                                          <div
                                            className='d-flex justify-content-center align-items-center'
                                            style={{
                                              position: 'absolute',
                                              inset: 0,
                                              background:
                                                'rgba(255,255,255,0.6)',
                                              borderRadius: 8,
                                            }}
                                          >
                                            <Spinner
                                              animation='border'
                                              size='sm'
                                            />
                                          </div>
                                        )}
                                        <img
                                          src={retestQrUrl}
                                          alt='QR thanh toán'
                                          className='img-fluid'
                                          style={{ maxWidth: 220 }}
                                          onLoad={handleQrLoad}
                                          onError={handleQrError}
                                        />
                                      </div>
                                      <div className='mt-2 small text-muted d-flex justify-content-center align-items-center'>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                          }}
                                        >
                                          <div
                                            style={{
                                              background: '#fff3bf',
                                              padding: '8px 12px',
                                              borderRadius: 8,
                                              fontFamily:
                                                'ui-monospace, SFMono-Regular, Menlo, Monaco, monospace',
                                            }}
                                          >
                                            {`Nội dung: ${retestTransferNote}`}
                                          </div>
                                          <div>
                                            <CopyButton
                                              text={retestTransferNote}
                                              iconOnly
                                              title='Sao chép nội dung chuyển khoản'
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Card.Body>
                              </Card>
                            </Col> */}
                          </Row>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Modal Tra cứu lịch giảng (nhóm XE - DỰ BỊ) */}
      <Modal
        show={showScheduleModal}
        onHide={() => {
          setShowScheduleModal(false);
          setCustomerData(null);
        }}
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>LỊCH GIẢNG CHÍNH KHÓA</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {datConditionLoading ? (
            <p className='text-center'>Đang tải dữ liệu...</p>
          ) : (
            <div>
              <p>
                <strong>XE / GIÁO VIÊN:</strong>{' '}
                {customerData?.mapper?.['account_name']?.display_value ||
                  customerData?.account_name ||
                  'Không có dữ liệu'}
              </p>
              <p>
                <strong>NHÓM QUẢN LÝ:</strong>{' '}
                {customerData?.mapper?.['account_source']?.display_value ||
                  'Không có dữ liệu'}
              </p>
              <p>
                <strong>NGÀY HẾT HẠN GPTL / BẰNG LÁI:</strong>{' '}
                {customerData?.mapper?.['ngay_kham_suc_khoe']?.display_value ||
                  'Không có dữ liệu'}
              </p>
              <hr />
              <p>
                <strong>CHÍNH KHÓA:</strong>{' '}
                {customerData?.mapper?.['khoa_hoc']?.display_value ||
                  'Không có dữ liệu'}
              </p>
              <p>
                <strong>NGÀY KHAI GIẢNG:</strong>{' '}
                {customerData?.mapper?.['ngay_khai_giang']?.display_value ||
                  'Không có dữ liệu'}
              </p>
              <p>
                <strong>NGÀY HỌC SA HÌNH:</strong>{' '}
                {customerData?.mapper?.['ngay_hoc_hih']?.display_value ||
                  'Không có dữ liệu'}
              </p>
              <p>
                <strong>NGÀY HỌC DAT:</strong>{' '}
                {customerData?.mapper?.['ngay_hoc_dat']?.display_value ||
                  'Không có dữ liệu'}
              </p>
              <p>
                <strong>NGÀY BẾ GIẢNG:</strong>{' '}
                {customerData?.mapper?.['ngay_be_giang']?.display_value ||
                  'Không có dữ liệu'}
              </p>
              <p>
                <strong>TRẠNG THÁI PHÂN CÔNG:</strong>{' '}
                {customerData?.mapper?.['relation_id']?.display_value ||
                  'Không có dữ liệu'}
              </p>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Retest Registration Modal */}
      <Modal
        show={showRetestModal}
        onHide={() => {
          setShowRetestModal(false);
          resetRetestForm();
          setShowCustomerDetail(true);
        }}
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>Đăng ký thi lại</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {retestRegistered ? (
            // Show success message with payment info
            <div>
              <div className='alert alert-success mb-3'>
                <h5>✓ Đăng ký thi lại thành công!</h5>
              </div>

              <Card className='mb-3'>
                <Card.Header>
                  <Card.Title>Thông tin đăng ký thi lại</Card.Title>
                </Card.Header>
                <Card.Body>
                  <p>
                    <strong>Họ và tên:</strong>{' '}
                    {customerData?.mapper?.['account_name']?.display_value ||
                      'Không có dữ liệu'}
                  </p>
                  <p>
                    <strong>Mã học viên:</strong>{' '}
                    {customerData?.mapper?.['ma_hoc_vien_theo_csdl']
                      ?.display_value || 'Không có dữ liệu'}
                  </p>
                  <p>
                    <strong>Ngày sinh:</strong>{' '}
                    {customerData?.mapper?.['birthday']?.display_value ||
                      'Không có dữ liệu'}
                  </p>
                </Card.Body>
              </Card>

              {/* <Card className='mb-3'>
                <Card.Header>
                  <Card.Title>Thông tin thanh toán thi lại</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={8}>
                      <Row className='mb-2'>
                        <Col md={4}>
                          <strong>Ngân hàng:</strong>
                        </Col>
                        <Col md={8}>
                          {paymentInfo.bankName}{' '}
                          <CopyButton
                            text={paymentInfo.bankAccount}
                            iconOnly
                            title='Sao chép STK'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-2'>
                        <Col md={4}>
                          <strong>Số tài khoản:</strong>
                        </Col>
                        <Col md={8}>
                          {paymentInfo.bankAccount}{' '}
                          <CopyButton
                            text={paymentInfo.bankAccount}
                            iconOnly
                            title='Sao chép STK'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-2'>
                        <Col md={4}>
                          <strong>Chủ tài khoản:</strong>
                        </Col>
                        <Col md={8}>{paymentInfo.bankOwner?.toUpperCase()}</Col>
                      </Row>
                    </Col>
                    <Col md={4} className='text-center'>
                      <div
                        className='position-relative d-inline-block'
                        style={{ maxWidth: '200px' }}
                      >
                        {qrLoading && (
                          <div
                            className='d-flex justify-content-center align-items-center'
                            style={{
                              position: 'absolute',
                              inset: 0,
                              background: 'rgba(255,255,255,0.6)',
                              borderRadius: 8,
                            }}
                          >
                            <Spinner animation='border' size='sm' />
                          </div>
                        )}
                        <img
                          src={retestQrUrl}
                          alt='QR Code chuyển khoản'
                          className='img-fluid'
                          style={{ maxWidth: '200px' }}
                          onLoad={handleQrLoad}
                          onError={handleQrError}
                        />
                      </div>
                      <div className='mt-2'>
                        <small className='text-muted d-block'>
                          Quét mã QR để chuyển khoản
                        </small>
                      </div>
                    </Col>
                  </Row>
                  <Row className='mt-3'>
                    <Col md={12}>
                      <div
                        style={{
                          background: '#fff3bf',
                          padding: '12px',
                          borderRadius: 8,
                          fontFamily:
                            'ui-monospace, SFMono-Regular, Menlo, Monaco, monospace',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <div>
                          <strong>Nội dung:</strong> {retestTransferNote}
                        </div>
                        <CopyButton
                          text={retestTransferNote}
                          iconOnly
                          title='Sao chép nội dung chuyển khoản'
                        />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card> */}

              <div className='d-flex justify-content-end'>
                <Button
                  variant='primary'
                  onClick={() => {
                    setShowRetestModal(false);
                    resetRetestForm();
                    setShowCustomerDetail(true);
                  }}
                >
                  Đóng
                </Button>
              </div>
            </div>
          ) : (
            // Show registration form
            <div>
              <Card className='mb-3'>
                <Card.Header>
                  <Card.Title>Thông tin học viên</Card.Title>
                </Card.Header>
                <Card.Body>
                  <p>
                    <strong>Tên:</strong>{' '}
                    {customerData?.mapper?.['account_name']?.display_value ||
                      'Không có dữ liệu'}
                  </p>
                  <p>
                    <strong>Mã học viên:</strong>{' '}
                    {customerData?.mapper?.['ma_hoc_vien_theo_csdl']
                      ?.display_value || 'Không có dữ liệu'}
                  </p>
                  <p>
                    <strong>Ngày sinh:</strong>{' '}
                    {customerData?.mapper?.['birthday']?.display_value ||
                      'Không có dữ liệu'}
                  </p>
                </Card.Body>
              </Card>

              {/* <Card className='mb-3'>
                <Card.Header>
                  <Card.Title>Thông tin thanh toán</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={8}>
                      <Row className='mb-2'>
                        <Col md={4}>
                          <strong>Ngân hàng:</strong>
                        </Col>
                        <Col md={8}>{paymentInfo.bankName}</Col>
                      </Row>
                      <Row className='mb-2'>
                        <Col md={4}>
                          <strong>Số tài khoản:</strong>
                        </Col>
                        <Col md={6}>{paymentInfo.bankAccount}</Col>
                        <Col md={2}>
                          <CopyButton
                            text={paymentInfo.bankAccount}
                            iconOnly
                            title='Sao chép STK'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-2'>
                        <Col md={4}>
                          <strong>Chủ tài khoản:</strong>
                        </Col>
                        <Col md={8}>{paymentInfo.bankOwner}</Col>
                      </Row>
                      <Row className='mb-2'>
                        <Col md={4}>
                          <strong>Nội dung CK:</strong>
                        </Col>
                        <Col md={6}>
                          <small className='text-muted'>
                            {retestTransferNote}
                          </small>
                        </Col>
                        <Col md={2}>
                          <CopyButton
                            text={retestTransferNote}
                            iconOnly
                            title='Sao chép nội dung'
                          />
                        </Col>
                      </Row>
                      <p className='text-danger'>
                        Lưu ý: Từ 1/1/2026 Thí sinh dự thi sát hạch sẽ được
                        Trung tâm Nộp hộ Phí sát hạch dự thi theo danh sách đăng
                        ký, Trong trường hợp VẮNG THI sẽ không được hoàn lại.
                        Khi dự thi lần tiếp theo sẽ đóng lại Phí đầy đủ các nội
                        dung dự thi.
                      </p>
                    </Col>
                    <Col md={4} className='text-center'>
                      <div
                        className='position-relative d-inline-block'
                        style={{ width: '100%', maxWidth: '200px' }}
                      >
                        {qrLoading && (
                          <div
                            className='d-flex justify-content-center align-items-center'
                            style={{
                              position: 'absolute',
                              inset: 0,
                              background: 'rgba(255,255,255,0.6)',
                              borderRadius: 8,
                            }}
                          >
                            <Spinner animation='border' size='sm' />
                          </div>
                        )}
                        <img
                          src={retestQrUrl}
                          alt='QR Code chuyển khoản'
                          style={{ width: '100%', maxWidth: '200px' }}
                          onLoad={handleQrLoad}
                          onError={handleQrError}
                        />
                      </div>
                      <small className='text-muted d-block mt-2'>
                        Quét mã QR để chuyển khoản
                      </small>
                    </Col>
                  </Row>
                </Card.Body>
              </Card> */}

              <Form onSubmit={handleRetestSubmit(registerForRetest)}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    Chọn hạng mục <span className='text-danger'>*</span>
                  </Form.Label>
                  <div
                    style={{
                      border: '1px solid #dee2e6',
                      borderRadius: '0.25rem',
                      padding: '10px',
                    }}
                  >
                    {retestCategoryPrices.theory.available && (
                      <Form.Check
                        type='checkbox'
                        id='theory-checkbox'
                        label={`Lý thuyết - ${currencyFormatter.format(
                          retestCategoryPrices.theory.price,
                        )}`}
                        checked={selectedRetestCategories.theory}
                        onChange={(e) =>
                          setSelectedRetestCategories((prev) => ({
                            ...prev,
                            theory: e.target.checked,
                          }))
                        }
                        className='mb-2'
                      />
                    )}
                    {retestCategoryPrices.simulation.available && (
                      <Form.Check
                        type='checkbox'
                        id='simulation-checkbox'
                        label={`Mô phỏng - ${currencyFormatter.format(
                          retestCategoryPrices.simulation.price,
                        )}`}
                        checked={selectedRetestCategories.simulation}
                        onChange={(e) =>
                          setSelectedRetestCategories((prev) => ({
                            ...prev,
                            simulation: e.target.checked,
                          }))
                        }
                        className='mb-2'
                      />
                    )}
                    {retestCategoryPrices.practice.available && (
                      <Form.Check
                        type='checkbox'
                        id='practice-checkbox'
                        label={`Sa hình - ${currencyFormatter.format(
                          retestCategoryPrices.practice.price,
                        )}`}
                        checked={selectedRetestCategories.practice}
                        onChange={(e) =>
                          setSelectedRetestCategories((prev) => ({
                            ...prev,
                            practice: e.target.checked,
                          }))
                        }
                        className='mb-2'
                      />
                    )}
                    {retestCategoryPrices.road.available && (
                      <Form.Check
                        type='checkbox'
                        id='road-checkbox'
                        label={`Đường trường - ${currencyFormatter.format(
                          retestCategoryPrices.road.price,
                        )}`}
                        checked={selectedRetestCategories.road}
                        onChange={(e) =>
                          setSelectedRetestCategories((prev) => ({
                            ...prev,
                            road: e.target.checked,
                          }))
                        }
                        className='mb-2'
                      />
                    )}
                  </div>
                  {selectedRetestPrice > 0 && (
                    <div className='mt-2'>
                      <strong>
                        Tổng tiền:{' '}
                        {currencyFormatter.format(selectedRetestPrice)}
                      </strong>
                    </div>
                  )}
                </Form.Group>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    Người nộp hồ sơ <span className='text-danger'>*</span>
                  </Form.Label>
                  <Form.Control
                    type='text'
                    {...retestRegister('applicant', {
                      required: 'Vui lòng nhập tên người nộp hồ sơ.',
                      maxLength: {
                        value: 10,
                        message: 'Không vượt quá 10 ký tự.',
                      },
                    })}
                    isInvalid={!!retestErrors.applicant}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {retestErrors.applicant?.message}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    Số điện thoại <span className='text-danger'>*</span>
                  </Form.Label>
                  <Form.Control
                    type='text'
                    {...retestRegister('phone', {
                      required: 'Vui lòng nhập số điện thoại.',
                      pattern: {
                        value: /^\d{10}$/,
                        message: 'Số điện thoại không hợp lệ.',
                      },
                    })}
                    isInvalid={!!retestErrors.phone}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {retestErrors.phone?.message}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    Ngày nộp tiền <span className='text-danger'>*</span>
                  </Form.Label>
                  <Form.Control
                    type='date'
                    min={todayStr}
                    {...retestRegister('paymentDate', {
                      required: 'Vui lòng chọn ngày nộp tiền.',
                    })}
                    isInvalid={!!retestErrors.paymentDate}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {retestErrors.paymentDate?.message}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className='d-flex justify-content-end gap-2'>
                  <Button
                    variant='secondary'
                    onClick={() => {
                      setShowRetestModal(false);
                      resetRetestForm();
                      setShowCustomerDetail(true);
                    }}
                  >
                    Hủy
                  </Button>
                  <Button variant='primary' type='submit' disabled={loading}>
                    {loading ? 'Đang xử lý...' : 'Xác nhận đăng ký'}
                  </Button>
                </div>
              </Form>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default SearchPageV2;
